import type { HealthSnapshot } from '@tailorcast/shared-types';

interface KpiTrendChartProps {
  snapshots: HealthSnapshot[];
}

export function KpiTrendChart({ snapshots }: KpiTrendChartProps) {
  if (snapshots.length < 2) {
    return <div className="text-sm text-gray-500">Not enough data for trend chart</div>;
  }

  const maxScore = Math.max(...snapshots.map((s) => s.storeHealthScore), 5);
  const height = 120;
  const width = 300;
  const padding = 20;

  const points = snapshots.map((s, i) => {
    const x = padding + (i / (snapshots.length - 1)) * (width - 2 * padding);
    const y = height - padding - (s.storeHealthScore / maxScore) * (height - 2 * padding);
    return { x, y, snapshot: s };
  });

  const pathD = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x} ${p.y}`).join(' ');

  return (
    <div className="card p-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Health Trend</h3>
      <svg viewBox={`0 0 ${width} ${height}`} className="w-full" style={{ maxHeight: 160 }}>
        <path d={pathD} fill="none" stroke="#6366F1" strokeWidth="2" />
        {points.map((p, i) => (
          <circle key={i} cx={p.x} cy={p.y} r="3" fill="#6366F1" />
        ))}
        {points.map((p, i) =>
          i === 0 || i === points.length - 1 ? (
            <text
              key={`label-${i}`}
              x={p.x}
              y={height - 2}
              textAnchor="middle"
              fontSize="8"
              fill="#9CA3AF"
            >
              {new Date(p.snapshot.date).toLocaleDateString(undefined, {
                month: 'short',
                day: 'numeric',
              })}
            </text>
          ) : null
        )}
      </svg>
    </div>
  );
}
